import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Articolo } from "../models/articolo";
import { Edizione } from "../models/edizione";
import { Sezione } from "../models/sezione";
import { Testata } from "../models/testata";
import { ILayoutConf } from "./layout.service";
import { LocalStorageServices } from "./local-storage.services";

export interface IPubblicazione{
    id: number,
    idEdizione: number,
    date: Date
}

@Injectable()
export class SharingService {
   
    private data: String;
    private title: string;
    private testata: Testata;
    private edizione: Edizione;
    private sezione: Sezione;
    private articolo: Articolo;
    private pubblicazione: IPubblicazione;
    
    constructor(private titleService:Title, private ls : LocalStorageServices) {}

    public init(){
        sessionStorage.clear();
    }

    set config(customConf: ILayoutConf){
        this.ls.setItem('CONFIG', customConf);
    }

    get config(): ILayoutConf{
        return this.ls.getItem('CONFIG');
    }

    public storeData(data: string) {
        sessionStorage.setItem('DATA', data)
        this.data = data;
    }

    public getData(){
        try{
            if(this.data!=null)
               return this.data;
            else
                return sessionStorage.getItem('DATA');
        }catch{
            return null
        }
    }

    public storeTestata(testata: Testata) {
        sessionStorage.setItem('TESTATA', JSON.stringify(testata))
        this.testata = testata;
    }

    public getTestata(){
        try{
            if(this.testata!=null)
                return this.testata;
            else
                return JSON.parse(sessionStorage.getItem('TESTATA'));
        }catch{
            return null
        }
    }

    public storeSezione(sezione: Sezione){
        sessionStorage.setItem('SEZIONE', JSON.stringify(sezione))
        this.sezione = sezione;
    }

    public getSezione(){
        try{
            if(this.sezione!=null)
                return this.sezione;
            else
                return JSON.parse(sessionStorage.getItem('SEZIONE'));
        }catch{
            return null
        }
    }

    public storeArticolo(articolo: Articolo) {
        sessionStorage.setItem('ARTICOLO', JSON.stringify(articolo));
        this.articolo = articolo;
    }

    public getArticolo(){
        try{
            if(this.articolo!=null)
                return this.articolo;
            else
                return JSON.parse(sessionStorage.getItem('ARTICOLO'));
        }catch{
            return null
        }
    }

    public storeEdizione(edizione: Edizione) {
        sessionStorage.setItem('EDIZIONE', JSON.stringify(edizione));
        this.edizione = edizione;
    }

    public getEdizione(){
        try{
            if(this.edizione!=null)
                return this.edizione;
            else
                return JSON.parse(sessionStorage.getItem('EDIZIONE'));
        }catch{
            return null
        }
    }

    public getTitle(titleVariable: String){  

        switch(titleVariable){

            case 'edizioneTitle':{
                this.title = this.getTestata().name;
                this.titleService.setTitle(this.title);   
                return this.title;
            }
            case 'sezioneTitle' :{
                this.title = this.getTestata().name + ", " + this.getEdizione().name;
                this.titleService.setTitle(this.title);   
                return this.title;
            }
            case 'elencoArticoloTitle':{
                this.title = this.getTestata().name + ", " + this.getEdizione().name + ", " + this.getSezione().sezione;
                this.titleService.setTitle(this.title);
                return this.title;
            } 
            case 'articoloTitle': {
                this.title = this.getTestata().name + ", " + this.getEdizione().name + ", " + this.getSezione().sezione + ", " + this.getArticolo().titolo;
                this.titleService.setTitle(this.title);
                return this.title;
            }
            case 'ricercaTitle':{
                this.title = this.getTestata().name + ", " + this.getEdizione().name;
                this.titleService.setTitle(this.title);
                return this.title;
            }
            default: { 
                break; 
            }
        }
    }
    
    public storePubblicazione(pubblicazione: IPubblicazione){
        sessionStorage.setItem('PUBBLICAZIONE', JSON.stringify(pubblicazione));
        this.pubblicazione = pubblicazione;
    }

    public getPubblicazione(){
        try{
            if(this.pubblicazione!=null)
                return this.pubblicazione;
            else
                return JSON.parse(sessionStorage.getItem('PUBBLICAZIONE'));
        }catch{
            return null
        }
    }
}